import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult } from 'firebase/auth';
import { db, auth as dbAuth } from '../lib/db';
import { doc, getDoc } from 'firebase/firestore';

export const auth = dbAuth;

export async function signInEmail(email, password){
  const cred = await signInWithEmailAndPassword(auth, email, password);
  const isAdmin = await checkAdmin(cred.user?.uid);
  if (!isAdmin) {
    await signOut(auth);
    throw new Error('This account is not authorized for admin.');
  }
  return cred.user;
}

export async function signInGoogle(){
  const provider = new GoogleAuthProvider();
  try {
    // Use popup since domain authorization is now fixed
    const result = await signInWithPopup(auth, provider);
    const isAdmin = await checkAdmin(result.user?.uid);
    if (!isAdmin) {
      await signOut(auth);
      throw new Error('This Google account is not authorized for admin access. Please contact support.');
    }
    return result.user;
  } catch (error) {
    // If popup is blocked, fall back to redirect
    if (error.code === 'auth/popup-blocked') {
      await signInWithRedirect(auth, provider);
      return null; // Will be handled by redirect result
    }
    throw error;
  }
}

export async function handleRedirectResult(){
  try {
    const result = await getRedirectResult(auth);
    if (result) {
      const isAdmin = await checkAdmin(result.user?.uid);
      if (!isAdmin) {
        await signOut(auth);
        throw new Error('This Google account is not authorized for admin.');
      }
      return result.user;
    }
    return null;
  } catch (error) {
    throw error;
  }
}

export function onAuth(cb){
  return onAuthStateChanged(auth, cb);
}

export async function checkAdmin(uid){
  if (!uid) {
    console.log('checkAdmin: No UID provided');
    return false;
  }
  
  console.log('checkAdmin: Checking admin status for UID:', uid);
  
  try {
    // Check in users collection for role-based admin access
    const userSnap = await getDoc(doc(db, 'users', uid));
    console.log('checkAdmin: User doc exists:', userSnap.exists());
    
    if (userSnap.exists()) {
      const userData = userSnap.data();
      console.log('checkAdmin: User data:', userData);
      if (userData?.role === 'admin') {
        console.log('checkAdmin: User has admin role');
        return true;
      }
    }
    
    // Fallback: check legacy admins collection
    const adminSnap = await getDoc(doc(db, 'admins', uid));
    console.log('checkAdmin: Admin doc exists:', adminSnap.exists());
    
    if (adminSnap.exists()) {
      const adminData = adminSnap.data();
      console.log('checkAdmin: Admin data:', adminData);
      if (adminData?.isAdmin === true) {
        console.log('checkAdmin: User has legacy admin access');
        return true;
      }
    }
    
    console.log('checkAdmin: No admin access found');
    return false;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

export async function logout(){
  await signOut(auth);
}
